export const ACTIONS = {
  CANCEL: 'cancel',
  HANDLE_INPUT_CHANGE: 'handleInputChange',
  SET_SENDING: 'setSending'
};

const reducer = (state, { payload, type }) => {
  switch (type) {
    case ACTIONS.CANCEL:
    case ACTIONS.HANDLE_INPUT_CHANGE:
      return {
        ...state,
        ...payload
      };
    case ACTIONS.SET_SENDING:
      return {
        ...state,
        sending: payload
      };
    default:
      return state;
  }
};

export default reducer;
